module.exports = __webpack_public_path__ + "static/img/sx_sq.e4f5436.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sx_sq.png
// module id = exke
// module chunks = 167